import { useQuery } from '@tanstack/react-query';
import { terraProxyApiClient } from '../../clients/testerClient';

export const APPLICATION_BY_ID_QUERY_KEY = 'application-by-id';

const getApplicationById = async (id: string) =>
  terraProxyApiClient.getApplicationById(id);

export const useApplicationById = ({
  id,
  enabled = true,
  staleTime = 30000,
  refetchOnMount,
  refetchOnWindowFocus = false,
}: {
  id: string | undefined;
  enabled?: boolean;
  staleTime?: number;
  refetchOnMount?: boolean | 'always';
  refetchOnWindowFocus?: boolean;
}) => {
  const result = useQuery({
    queryKey: [APPLICATION_BY_ID_QUERY_KEY, id],
    queryFn: () => {
      if (!id) {
        throw new Error('Application ID is required');
      }
      return getApplicationById(id);
    },
    enabled: !!id && enabled,
    staleTime,
    refetchOnMount,
    refetchOnWindowFocus,
  });

  return {
    application: result.data,
    isLoading: result.isLoading,
    error: result.error,
  };
};
